module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loaded) ? _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.$route.name === 'review') ? _c('router-link', {
    staticClass: "nav-back",
    attrs: {
      "tag": "div",
      "to": {
        name: 'order'
      }
    }
  }, [_c('icons', {
    attrs: {
      "icon": "chevron-left"
    }
  }), _vm._v("\n                Back\n            ")], 1) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'order') ? _c('router-link', {
    staticClass: "nav-back",
    attrs: {
      "tag": "div",
      "to": {
        name: 'home'
      }
    }
  }, [_c('icons', {
    attrs: {
      "icon": "chevron-left"
    }
  }), _vm._v("\n                Back\n            ")], 1) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'confirmation') ? _c('router-link', {
    staticClass: "nav-back",
    attrs: {
      "tag": "div",
      "to": {
        name: 'home'
      }
    }
  }, [_c('icons', {
    attrs: {
      "icon": "chevron-left"
    }
  }), _vm._v("\n                Home\n            ")], 1) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'home' && _vm.menuReady) ? _c('div', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "menu-toggle",
    on: {
      "click": function($event) {
        _vm.menuOpen = !_vm.menuOpen
      }
    }
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-down"
    }
  }, [(_vm.menuOpen && _vm.autoHideMenu || !_vm.autoHideMenu) ? _c('ul', [_c('li', {
    class: {
      'active': _vm.trigger === 'what-is-it'
    }
  }, [_c('a', {
    attrs: {
      "href": "#what-is-it"
    },
    on: {
      "click": function($event) {
        _vm.menuOpen = false
      }
    }
  }, [_vm._v("What is it?")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.trigger === 'fabric'
    }
  }, [_c('a', {
    attrs: {
      "href": "#fabric"
    },
    on: {
      "click": function($event) {
        _vm.menuOpen = false
      }
    }
  }, [_vm._v("Fabric")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.trigger === 'hardware'
    }
  }, [_c('a', {
    attrs: {
      "href": "#hardware"
    },
    on: {
      "click": function($event) {
        _vm.menuOpen = false
      }
    }
  }, [_vm._v("Hardware")])]), _c('li', {
    class: {
      'active': _vm.trigger === 'sizes'
    }
  }, [_c('a', {
    attrs: {
      "href": "#sizes"
    },
    on: {
      "click": function($event) {
        _vm.menuOpen = false
      }
    }
  }, [_vm._v("Sizes")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.trigger === 'colors'
    }
  }, [_c('a', {
    attrs: {
      "href": "#colors"
    },
    on: {
      "click": function($event) {
        _vm.menuOpen = false
      }
    }
  }, [_vm._v("Colors")])])]) : _vm._e()])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.$route.name !== 'review' && _vm.$route.name !== 'confirmation') ? _c('div', {
    staticClass: "cart"
  }, [_c('div', {
    class: {
      'cart-icon': true, 'open': _vm.cartOpen
    },
    on: {
      "click": function($event) {
        _vm.cartOpen = !_vm.cartOpen
      }
    }
  }, [_c('icons', {
    attrs: {
      "icon": "cart"
    }
  }), _vm._v("\n                CART "), (_vm.cartItems.length > 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.cartItems.length) + ")")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: {
      'cart-menu': true, 'open': _vm.cartOpen
    }
  }, [_c('popup-cart', {
    on: {
      "hideCart": function($event) {
        _vm.cartOpen = false
      }
    }
  })], 1)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "main"
    },
    on: {
      "click": function($event) {
        _vm.menuOpen = _vm.cartOpen = false
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.activeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    on: {
      "triggered": _vm.captureTrigger,
      "openCart": function($event) {
        _vm.cartOpen = true
      },
      "closeCart": function($event) {
        _vm.cartOpen = false
      }
    }
  })], 1), _vm._v(" "), _vm._m(0)], 1)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', [_c('img', {
    staticClass: "footer-logo",
    attrs: {
      "src": "/img/hilsport.svg"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n                All Rights Reserved\n                "), _c('br'), _vm._v("\n                Copyright © 2020\n                "), _c('br'), _vm._v("\n                Made in USA\n                "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://goo.gl/maps/nBsFnS5sxVG2",
      "target": "_blank"
    }
  }, [_vm._v("\n                    25691 Altas Palmas Rd\n                    "), _c('br'), _vm._v("\n                    Harlingen, TX 78552\n                ")])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Get in touch")]), _vm._v(" "), _c('br'), _vm._v("\n                Call "), _c('strong', [_c('a', {
    attrs: {
      "href": "tel:18004519236"
    }
  }, [_vm._v("1 (800) 451-9236")])]), _vm._v(" "), _c('br'), _vm._v("\n                       "), _c('strong', [_c('a', {
    attrs: {
      "href": "tel:19564231885"
    }
  }, [_vm._v("1 (956) 423-1885")])]), _vm._v(" "), _c('br'), _vm._v("\n                Email "), _c('strong', [_c('a', {
    attrs: {
      "href": "mailto:service@hilsport.com"
    }
  }, [_vm._v("service@hilsport.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25441132","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 213
// module chunks = 1